import styled from 'types/theme.types';
import { WarningOutlined } from '@ant-design/icons';

export const WarningIcon = styled(WarningOutlined)`
  color: ${({ theme }) => theme.errorRed};
`;
